import { get } from "oj-ajax"

const getContent = async () => {
    const culture = document.querySelector("[data-culture]") as HTMLInputElement
    const variantId = document.querySelector("[data-variant-id]") as HTMLInputElement

    if ((!variantId || variantId.value === "") && (!culture || culture.value === ""))
        return

    const htmlObject = document.createElement('div')
    htmlObject.innerHTML = await get<string>(`${culture.value}product/GetDeliveryTagContent?productVariantId=${variantId.value}`)

    const currentTags = document.querySelectorAll("[data-replace-tag]")
    if (!currentTags)
        return

    const newTags = htmlObject.querySelectorAll("[data-replace-tag]")
    if (!newTags)
        return

    Array.from(currentTags)
        .forEach((x, i) => {
            x.innerHTML = ""
            x.innerHTML = newTags[0].innerHTML
        })
}

window["variantUpdated"] = getContent
